import { Alert, Button, Divider, Space, Spin, Tabs, Tag } from 'antd'
import React from 'react'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI'
import { IntegrationType } from './common'
import IntegrationsTable from './IntegrationsTable'
import WebhookIntegrationTable from './WebhookIntegrationTable'
import _, { isEmpty } from 'lodash'
import { LoadingIcon, ExternalLinkIcon } from 'components/Icons'
import ModalUtil from 'utils/modalUtil'
import IngestionScriptFormPopup from './IngestionScriptFormPopup';
import WebHookGenerateFormPopup from './WebHookGenerateFormPopup'
import CustomToolMapSettings from './CustomToolMapSettings'
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { withGlobalFilterContext } from 'contexts/GlobalFilterContext'
import ToolNotificationsListing from 'views/ToolSettings/Notifications/ToolNotificationsListing';
import ToolSettingsListing from 'views/ToolSettings/Settings/ToolSettingsListing';

import RunOnDemand from './RunOnDemand'
import { withFeatureFlags } from "contexts/FeatureFlagContext";
import { toolsName } from 'views/GlobalSettings/ToolsName';
import { hasPermission } from 'utils/authService'
import DISCOVERY_SUPPORTED_TOOLS from 'views/ProductDiscovery/supportedTools'
import { parseURLHash } from 'utils/urlUtil'
import { getAllScan } from 'views/scanresult/scanUtil'
import ScanListing from 'views/scanresult/ScanListing'

const alertTools = [toolsName.DEPENDABOT, toolsName.GITHUB_CODE_SCAN]
export default  withGlobalFilterContext(withRouter(withFeatureFlags(class GenericPullAndPushToolView extends React.Component{
    cancelPullAPI(){
        _.isFunction(this.cancelPullLoginAPI) && this.cancelPullLoginAPI();
        _.isFunction(this.cancelPullConfigAPI) && this.cancelPullConfigAPI();
    }
    cancelPushAPI = _.noop;
    cancelScanUploadAPI = _.noop;
    cancelWebHookAPI = _.noop
    tableRef = React.createRef();
    constructor(props){
        super(props);
        this.cancelNotificationAPI = _.noop;
        this.renderPushNewForm = this.renderPushEditForm.bind(this, null);
        this.renderWebHookNewForm = this.renderWebHookEditForm.bind(this, null);
        const { defaultTab, defaultActiveLoginConfigId } = parseURLHash(window.location.hash)?.filters || {};

        this.state = {
            loadingPullConfigs: true,
            loadingPushConfigs: true,
            loadingWebHookConfigs: true,
            uploadScanCount: undefined,
            settingsCount: undefined,
            allCustomTool: [],
            defaultTab: defaultTab?.[0],
            defaultActiveLoginConfigId: defaultActiveLoginConfigId?.[0]
        }
        
        _.bindAll(
            this,
            "renderPushEditForm",
            "renderWebHookEditForm",
            "renderWebHookNewForm",
            "getPushConfigs",
            "onPushConfigAction",
            "onTabChange",
            "getPullConfigs",
            "renderPullNewForm",
            "onPullConfigAction",
            "getUploadScans",
            "getWebHookConfigs",
            "onWebHookConfigAction",
            "getFilters"
        )
    }
    componentWillUnmount(){
        this.cancelPullAPI();
        this.cancelPushAPI();
        this.cancelScanUploadAPI();
        this.cancelWebHookAPI();
        this.cancelNotificationAPI();
    }
    componentDidMount(){
        this.getPullConfigs(true);
        this.getUploadScans(true);
        this.getWebHookConfigs(true);
        this.updateToolStatus();
        this.getPushConfigs(true);
        // this.getSettingsCount();
    }
    componentDidUpdate(prevProps) {
        if(!_.isEqual(prevProps.globalFilterContext.globalFilterHash, this.props.globalFilterContext.globalFilterHash)) {
            this.getPullConfigs(true);
            this.getUploadScans(true);
            this.getWebHookConfigs(true);
            this.getPushConfigs(true);
        }
    }
    updateToolStatus(){
        const toolName = this.toolNameForAPI;
        const { promise, cancel } = ToolsIntegrationsAPI.getAppSecToolsStatus({ toolName });
        this.cancelStatusAPI = cancel;
        promise.then(data => {
            const toolInfo = _.find(data, { toolName });
            if(toolInfo){
                this.setState({ pullConfigs: toolInfo.integrations });
                this.props.updateMainList(toolInfo.integrations, this.props.name);
            }
        });
    }
    onTabChange(activeTab){
        switch(activeTab){
            case IntegrationType.PUSH:
                break;
            case IntegrationType.PULL:
                this.getPullConfigs();
                break;
            case IntegrationType.WEBHOOK:
                this.getWebHookConfigs();
                break;
            default:
                return
        }
        this.updateToolStatus();
    }
    onPushConfigAction(bool){
        this.getPushConfigs();
        this.props.onUpdateConfigComponent(bool);
        this.updateToolStatus();
        this.tableRef.current?.refresh();
    }
    get toolNameForAPI(){
        const { name } = this.props;
        return toolNameForAPI(name)
    }
    
    getPushConfigs(noCancel, params){
        const { hidePushView } = this.props;
        if(hidePushView){
            return;
        }
        if(!noCancel){
            this.cancelPullAPI();
            this.cancelWebHookAPI();
        }

        this.setState({ loadingPushConfigs: true });
        
        const obj = {
            ...(_.isUndefined(params) ? {} : params ),
            toolType: IntegrationType.PUSH
        }


        const { promise, cancel } = ToolsIntegrationsAPI.getGenericConfigurationsByToolName(this.toolNameForAPI, obj);
        const processedPromise = promise.then(res => {
            const updated = {
                ...res,
                content: res.configurations
            }
            
            delete updated.configurations;
            this.setState({pushConfigs: res?.totalElements, loadingPushConfigs:false})
            return updated;
        });
        
        return { promise: processedPromise, cancel };
    }

    getFilters(){
        return ToolsIntegrationsAPI.getGenericEvolvedFilteredConfigurationsByToolName(this.toolNameForAPI, { toolType: IntegrationType.PUSH })
    }

    renderPushEditForm(record){
        ModalUtil.show({
            content: <IngestionScriptFormPopup {...this.props} data={record} />,
            afterClose: (data) => {
                if(data){
                    this.onPushConfigAction(true);
                    this.tableRef.current?.refresh();
                }
            }
        })
    }

    renderPushTab(){
        const { pushConfigs, loadingPushConfigs } = this.state;
        
        return (
            <Tabs.TabPane tab={<>Push script <Tag className="m-0">{pushConfigs ?? 0}</Tag></>} key={IntegrationType.PUSH}>
                <Spin spinning={loadingPushConfigs} indicator={<LoadingIcon />}>
                    <IntegrationsTable 
                        {...this.props}
                        tableRef={this.tableRef}
                        onUpdateConfigComponent={this.onPushConfigAction}
                        api={(params) => this.getPushConfigs(true, params)}
                        filtersApi={this.getFilters}
                        suspendAPI={ToolsIntegrationsAPI.updateGenericConfigurationByToolName}
                        deleteAPI={ToolsIntegrationsAPI.deleteGenericConfigurationByToolName}
                        showHideForm={this.renderPushEditForm}
                        extras={
                            <Space>
                                {this.props.pushScriptInfo && <><span className='success'>{this.props.pushScriptInfo}</span> <Divider type="vertical" className="m-0" /></>}
                                <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} >
                                    <Button
                                        size="small" type="primary"
                                        onClick={this.renderPushNewForm}
                                    >
                                        Add
                                    </Button>
                                </AuthorisedContainer>
                            </Space>
                        }
                    />
                </Spin>
            </Tabs.TabPane>
        )
    }
    onWebHookConfigAction(bool){
        this.getWebHookConfigs();
        this.props.onUpdateConfigComponent(bool);
        this.updateToolStatus();
    }

    getWebHookConfigs(noCancel){
        const { showWebHookView } = this.props;
        if(!showWebHookView){
            return;
        }
        if(!noCancel){
            this.cancelPushAPI();
            this.cancelPullAPI();
        }
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericConfigurationsByToolName(this.toolNameForAPI, { toolType: IntegrationType.WEBHOOK });
        this.setState({ loadingWebHookConfigs: true });
        this.cancelWebHookAPI = cancel;
        promise.then(({ configurations: webHookConfigs }) => {
            this.setState({ webHookConfigs, loadingWebHookConfigs: false });
        }, _.noop);
    }

    renderWebHookEditForm(record){
        ModalUtil.show({
            content: <WebHookGenerateFormPopup {...this.props} data={record} />,
            afterClose: (data) => {
                if(data){
                    this.onWebHookConfigAction(true);
                }
            }
        })
    }

    renderWebHookTab(){
        const { webHookConfigs, loadingWebHookConfigs } = this.state;
        return (
            <Tabs.TabPane tab={<>WebHook <Tag className="m-0">{webHookConfigs?.length??0}</Tag></>} key={IntegrationType.WEBHOOK}>
                <Spin spinning={loadingWebHookConfigs} indicator={<LoadingIcon />}>
                    <WebhookIntegrationTable 
                        {...this.props}
                        onUpdateConfigComponent={this.onWebHookConfigAction}
                        data={webHookConfigs}
                        suspendAPI={ToolsIntegrationsAPI.updateWebhookConfigurationByToolName}
                        deleteAPI={ToolsIntegrationsAPI.deleteGenericConfigurationByToolName}
                        showHideForm={this.renderWebHookEditForm}
                        webHookEdit={true}
                        extras={
                            <Space>
                                {this.props.webHookInfo && <><span className='success'>{this.props.webHookInfo}</span></>}
                                {!this.props.deprecateWebhook && 
                                <> 
                                    <Divider type="vertical" />
                                    <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} >
                                        <Button
                                            size="small" type="primary"
                                            onClick={this.renderWebHookNewForm}
                                        >
                                            Add
                                        </Button>
                                    </AuthorisedContainer>
                                </>}
                            </Space>
                        }
                    />
                </Spin>
            </Tabs.TabPane>
        )
    }
    onPullConfigAction(bool){
        this.getPullConfigs();
        this.props.onUpdateConfigComponent(bool);
        this.updateToolStatus();
    }
    getPullConfigs(noCancel){
        const { hidePullView } = this.props;
        if(hidePullView){
            return;
        }
        if(!noCancel){
            this.cancelPushAPI();
            this.cancelWebHookAPI();
        }
        this.setState({ loadingPullConfigs: true });
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericLoginDetail(this.toolNameForAPI);
        this.cancelPullLoginAPI = cancel;

        Promise.all([promise]).then(([{ configurations: pullLoginDetails }]) => {
        this.setState({ 
            pullLoginDetails,
            loadingPullConfigs: false
        })
        }, console.error);  

    }
    renderPullNewForm(){
        const { PullCredentialForm } = this.props;
        ModalUtil.show({
            content: <PullCredentialForm {...this.props} onUpdateConfigComponent={this.onPullConfigAction} />,
            afterClose: (data) => {
                if(data){
                    this.onPullConfigAction(true);
                }
            }
        })
    }
    renderPullTab(){
        const { pullLoginDetails, loadingPullConfigs, defaultActiveLoginConfigId } = this.state;
        const { PullConfigListingView, name, RunOnDemandButtonText } = this.props;
        const allPullConfigCount = _.reduce(pullLoginDetails, (sum, n) => sum + n.total_configurations, 0);
        const { featureFlags } = this.props;
        let noDataMessage = null;
        if (alertTools.indexOf(name) !== -1) {
            noDataMessage = (
                <div className='d-flex justify-content-center text-bold'>
                    <Alert type='warning' className='message' message={<>A scan will not trigger if {name}'s required settings are not enabled. You can learn more about settings by <a style={{ color: 'inherit', textDecoration: 'underline' }} href={getToolLink(name)} rel="noopener noreferrer" target="_blank">clicking here<ExternalLinkIcon className="m-l-xs" /></a></>} />
                </div>
            );
        }
        return (
            <Tabs.TabPane tab={<>API <Tag className="m-0">{allPullConfigCount}</Tag></>} key={IntegrationType.PULL}>
                <Spin spinning={loadingPullConfigs} indicator={<LoadingIcon />}>
                    <div className="text-right m-b-sm">
                        <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} >
                            <Button
                                size="small" type="primary"
                                onClick={this.renderPullNewForm}
                            >
                                Add Configuration
                            </Button>
                            {[
                      "Mend.io",
                      "Snyk",
                      "Checkmarx",
                      "Fortify",
                      "Prisma Cloud Twistlock",
                      "Mend",
                      "Blackduck Hub",
                      "Checkmarx One",
                      "Edgescan",
                      DISCOVERY_SUPPORTED_TOOLS.Coverity,
                      "Rapid7 InsightVM",
                      "FiniteState",
                      "GitGuardian",
                      "SonarQube",
                      "Veracode",
                      "Aqua",
                      "Apiiro",
                      "Contrast Security",
                      "Acunetix",
                      "Sonatype Lifecycle",
                      DISCOVERY_SUPPORTED_TOOLS.PrismaCloudRedlock,
                      DISCOVERY_SUPPORTED_TOOLS.TenableCloudSecurity,
                      "AppCheck",
                      "Cycode",
                      DISCOVERY_SUPPORTED_TOOLS.CoverityOnPolaris,
                      "Qualys Infrastructure",
                      "SD Elements",
                      "Sonarcloud",
                      "Netsparker",
                      "Checkmarx SCA",
                      "SentinelOne",
                      "Microsoft Defender for Cloud",
                      "Endor Labs",
                      "Orca Security",
                      "Stackhawk",
                      "Microsoft Defender for Endpoint",
                      ...(featureFlags.JFROG_VISION_VDOO
                        ? ["JFrog Vision (Vdoo)"]
                        : []),
                      "RiskRecon",
                      ...(["Privado"]),
                        "JFrog Xray",
                        "Dependency Track",
                        DISCOVERY_SUPPORTED_TOOLS.Semgrep,
                        "Qualys WebApp",
                        DISCOVERY_SUPPORTED_TOOLS.SynopsysPolaris,
                        "Orca Security Shiftleft",
                        "Noname",
                        DISCOVERY_SUPPORTED_TOOLS.SocketDev,
                        DISCOVERY_SUPPORTED_TOOLS.AcunetixPremium,
                        DISCOVERY_SUPPORTED_TOOLS.Cybeats,
                        DISCOVERY_SUPPORTED_TOOLS.ReversingLabsSpectra,
                        DISCOVERY_SUPPORTED_TOOLS.WhiteHatSentinel,
                        DISCOVERY_SUPPORTED_TOOLS.ThreatModeler,
                        DISCOVERY_SUPPORTED_TOOLS.BlackduckBinaryAnalysis,
                        DISCOVERY_SUPPORTED_TOOLS.Ostorlab,
                        DISCOVERY_SUPPORTED_TOOLS.Arnica,
                        DISCOVERY_SUPPORTED_TOOLS.HCLAppscan,
                        DISCOVERY_SUPPORTED_TOOLS.HCLAppscanOnCloud,
                        DISCOVERY_SUPPORTED_TOOLS.PentestTools,
                        DISCOVERY_SUPPORTED_TOOLS.BurpSuiteEnterprise,
                        DISCOVERY_SUPPORTED_TOOLS.ApiSec,
                        DISCOVERY_SUPPORTED_TOOLS.TenableWebapp,
                        DISCOVERY_SUPPORTED_TOOLS.UltraViolet,
                        DISCOVERY_SUPPORTED_TOOLS.IriusRisk
                    ].includes(name) && <RunOnDemand buttonText={RunOnDemandButtonText} toolName={name} updateConfig={this.getPullConfigs} disableSyncProject={_.isEmpty(pullLoginDetails)} />}
                        </AuthorisedContainer>
                    </div>
                    <PullConfigListingView 
                        {...this.props} 
                        loginConfigList={pullLoginDetails} 
                        suspendAPI={ToolsIntegrationsAPI.updateGenericConfigurationByToolName}
                        deleteAPI={ToolsIntegrationsAPI.deleteGenericConfigurationByToolName} 
                        onUpdateConfigComponent={this.onPullConfigAction}
                        noDataMessage={noDataMessage}
                        defaultActiveLoginConfigId={defaultActiveLoginConfigId}
                    />
                </Spin>
            </Tabs.TabPane>
        )
    }

    getUploadScans(noCancel ){
        const { hidePushView } = this.props;
        if(hidePushView){
            return;
        }
        !noCancel && this.cancelScanUploadAPI();
        const { name: toolName, scanName } = this.props;
        const { cancel, promise } = getAllScan({ props: { scanName, toolName, triggerby:"UI_UPLOAD" } }, { size: 1 });
        this.cancelScanUploadAPI = cancel;

        promise.then(data => {
            this.setState({
                uploadScanCount: data.totalElements || 0
            })
        }, (error) => {
            console.error('Error in pullAndPushData:', error);
        });
    }
    renderUploadscanTab(){
        const { name: toolName , scanName, scanInfo } = this.props;
        const { uploadScanCount } = this.state;
        return (
            <Tabs.TabPane tab={<>Scan upload {_.isUndefined(uploadScanCount) ? <LoadingIcon /> : <Tag className="m-0">{uploadScanCount}</Tag>}</>} key={"SCAN_UPLOADS"}>
                <ScanListing tableKey='security-tool-scan-upload-list-table' toolName={toolNameForAPI(toolName)} scanName={scanName} onScanUploadSuccess={this.getUploadScans} scanInfo={scanInfo} triggerby="UI_UPLOAD"/>
            </Tabs.TabPane >
        )
    }

    renderFieldsMappingTab(){
        const { id: toolId } = this.props;
        return (
            <Tabs.TabPane tab="Fields Mapping" key="FIELDS_MAPPING">
                <CustomToolMapSettings toolId={toolId}/>
            </Tabs.TabPane>
        )
    }

    // async getSettingsCount() {
    //     this.cancelNotificationAPI();
    //     try {
    //         const { promise, cancel }  = AlertsAPI.getAlertNotification(this.props.name, 1);
    //         this.cancelNotificationAPI = cancel;
    //         const data = await promise;
    //         this.setState({ settingsCount: data.totalElements });
    //     } catch(e) {
    //         this.setState({ settingsCount: 0 });
    //     }
    // }

    renderSettingsTab(){
        // const { settingsCount } = this.state;

        return (
            <Tabs.TabPane tab={<>Settings</>} key="SETTINGS">
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="General" key="1">
                        <ToolSettingsListing {...this.props} pullLoginDetails={this.state.pullLoginDetails}/>
                    </Tabs.TabPane>       
                    <Tabs.TabPane tab="Notifications" key="2">
                        <ToolNotificationsListing {...this.props} />
                    </Tabs.TabPane>
                </Tabs>
            </Tabs.TabPane>
        )
    }

    render(){
        const { hidePullView , hidePushView, hideSetting, showWebHookView, showMappings, webHookfeatureKey, featureFlags, deprecateWebhook } = this.props

        const { defaultTab, webHookConfigs } = this.state;

        const hideWebhookTabConditionally = deprecateWebhook && isEmpty(webHookConfigs);

        return (
            <Tabs size="small" onChange={this.onTabChange} defaultActiveKey={defaultTab}>
                {!hidePullView && this.renderPullTab()}
                {showWebHookView && !hideWebhookTabConditionally && (_.isUndefined(webHookfeatureKey) ? true : featureFlags[webHookfeatureKey] ) && this.renderWebHookTab()}
                {!hidePushView && this.renderPushTab()}
                {!hidePushView && this.renderUploadscanTab()}
                {showMappings && this.renderFieldsMappingTab()}
                {!hideSetting && hasPermission(PermissionSetMap.READ_TOOL_SETTINGS) && this.renderSettingsTab()}
            </Tabs>
        )
    }
})))

export function toolNameForAPI(name,integration){
    //Need the AWS integration tool name as it is for the API
    if(integration && ["AWS Infrastructure"].indexOf(name) === -1){
        return name.toUpperCase().replaceAll(' ','_');
    }
    return name;
}
function getToolLink(name) { 
    let link = window.location.origin;
    switch (name) {
        case toolsName.GITHUB_CODE_SCAN:
            link += `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19638133899539--Github-Code-Scan#prerequisites`;
            break;
        case toolsName.DEPENDABOT:
            link += `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19637752842899-GitHub-Dependabot#prerequisites`;
            break;
        default:
            break;
    }
    return link;
}